import { Link } from "@mui/material";

const MNLink = ({ title, link }) => (
  <Link
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    underline="hover"
    variant="caption"
    sx={{ textDecoration: { xs: "underline", sm: "none" } }}
  >
    {title}
  </Link>
);

export default MNLink;
